<template>
<div class="no-results-found">
    <b-icon v-if="route!=='load_market'" class="search-icon" icon="search" variant="secondary" font-scale="2"></b-icon>
    <p v-if="route!=='load_market'" class="no-results-title">{{ $t('message.noResults_found') }}</p>
    <p v-if="route!=='load_market'" class="no-results-body">{{ $t('message.sub_text') }}</p>
    <b-icon v-if="route==='load_market'" class="exclamation-circle-fill" icon="exclamation-circle-fill" variant="secondary" font-scale="2"></b-icon>
    <p v-if="route==='load_market'" class="no-results-title">{{ $t('message.noOpenLoads') }}</p>
    <p v-if="route==='load_market'" class="no-results-body">{{ $t('message.noOpenLoads_sub_text') }}</p>
</div>
</template>
<script>
export default {
  props: {
    route: String,
  },
  async mounted() {
  }
}
</script>
<style>
.no-results-found{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.search-icon{
    margin-bottom: 5px;
    margin-top: 10px;
}
.no-results-title{
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.15px;
    margin-top:10px;
}
.no-results-body{
    color: #707070;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    line-height: 20px;
    padding-left:30px;
    padding-right:30px;
}
</style>
